module.exports = __webpack_public_path__ + "static/media/item-view.caf30e6d.jpg";